import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const ChannelListChannelItemContainer = styled.div<React.CSSProperties>`
  align-items: center;
  display: flex;
  height: ${80 * Screen.widthRatio}px;
  margin-bottom: ${24 * Screen.widthRatio}px;
`;

export default ChannelListChannelItemContainer;
